"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainInvoice = mapToDomainInvoice;
const OrderMapper_1 = require("../../../orders/infra/mappers/OrderMapper");
function mapToDomainInvoice(dto) {
    return {
        id: dto.id,
        clubId: dto.clubId,
        clubName: dto.clubName,
        machineId: dto.machineId,
        machineName: dto.machineName,
        orderStartTs: dto.orderStartTs,
        operationId: dto.operationId,
        amountPaid: dto.amountPaid,
        invoiceId: dto.invoiceId,
        //invoiceNumber: dto.invoiceNumber,
        invoiceType: dto.invoiceType,
        recapitulativeInvoiceId: dto.recapitulativeInvoiceId,
        recapitulativeInvoiceNumber: dto.recapitulativeInvoiceNumber,
        rateAmount: dto.rateAmount,
        exceedsPreauthLimit: dto.exceedsPreauthLimit ?? false,
        orderItems: dto.orderItems.map((item) => ({
            aisleCode: item.aisleCode,
            aisleName: item.aisleName,
            imgUrl: item.imgUrl,
            thumbnailUrl: item.thumbnailUrl,
            productName: item.productName,
            price: item.price ?? 0,
            amount: item.amount,
            payAmount: item.payAmount ?? 0,
            category: item.category,
            currency: item.currency,
            isReturn: item.isReturn ?? false,
        })),
        vatDetails: dto.vatDetails.map((vat) => ({
            vatPercent: vat.vatPercent,
            taxBase: vat.taxBase,
            vatAmount: vat.vatAmount,
        })),
        totalTaxBase: dto.totalTaxBase,
        totalVatAmount: dto.totalVatAmount,
        taxedAmount: dto.taxedAmount,
        ratePercent: dto.ratePercent,
        orderEndTs: dto.orderEndTs,
        customer: dto.customer,
        billingVerificationSystem: dto.billingVerificationSystem,
        returnHistory: (dto.returnHistory ?? []).map((entry) => ({
            user: entry.user,
            customer: entry.customer,
            total: entry.total,
            date: entry.date,
        })),
        preauthAdjustment: (0, OrderMapper_1.mapPreauthAdjustment)(dto.preauthAdjustment),
    };
}
function mapToFiscalAddress(dto) {
    return {
        street: dto.street,
        city: dto.city,
        state: dto.state,
        postalCode: dto.postalCode,
        country: dto.country,
    };
}
